import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import momentLocalizer from 'react-widgets-moment';
import RwDateTimePicker from 'react-widgets/lib/DateTimePicker';
import 'react-widgets/lib/scss/react-widgets.scss';

import { getTimezoneOffset } from 'common/selectors/index';
import { mutateInputWithCurrentTime } from 'common/util/dateTime';
import { DATE_TIME } from 'common/util/dateTime';

momentLocalizer(moment);

class DateTimePicker extends Component {
    focus() {
        this.element.focus();
    }

    getDateNoTime(date) {
        if (!date) {
            return null;
        }

        const momentDate = moment.utc(date);
        return new Date(momentDate.year(), momentDate.month(), momentDate.date());
    }

    /* A simple hack to calculate the TZ offset because the tansition to a JS Date object
    applies the local timezone on initialization */
    convertValueToDate(value) {
        if (value && this.props.noTimezone) {
            return this.getDateNoTime(value);
        } else if (value) {
            const mutatedValue = this.includeTime()? moment(value) : mutateInputWithCurrentTime(value, 'DATEONLY');
            const newValue = mutatedValue.add(this.caculateOffset(value), 'minutes');
            return newValue.toDate();
        }
    }

    caculateOffset(value) {
        const { timezoneOffset } = this.props;
        if(timezoneOffset) {
            const timeWithTimezone = moment(value).utcOffset(timezoneOffset);
            const timezoneOffsetValue = timeWithTimezone.utcOffset();
            const localOffsetValue = moment().utcOffset();
            return (localOffsetValue * -1) - (timezoneOffsetValue * -1);
        }
    }

    includeTime() {
        return this.props.time === true;
    }

    getFormat() {
        return this.includeTime() ? DATE_TIME.DATE_TIME_FORMAT : DATE_TIME.DATE_ONLY_FORMAT;
    }

    getPlaceholder() {
        return this.includeTime() ? DATE_TIME.DATE_TIME_PLACEHOLDER : DATE_TIME.DATE_ONLY_PLACEHOLDER;
    }

    render() {
        const { value } = this.props;
        return (
            <RwDateTimePicker ref={e => this.element = e}
                {...this.props}
                value={this.convertValueToDate(value)}
                format={this.getFormat()}
                placeholder={this.getPlaceholder()}
                data-cy="DateTimePicker"
            />
        );
    }
}

export default connect((state, props) => {
    return {
        timezoneOffset: getTimezoneOffset(state),
    };
}, {

})(DateTimePicker);


// DOCS http://jquense.github.io/react-widgets/docs/#/datetime-picker
DateTimePicker.propTypes = RwDateTimePicker.propTypes;

DateTimePicker.propTypes = {
    timezoneOffset: PropTypes.string
};

// export default DateTimePicker;
